/**
 * Lê a mensagem de erro de uma requisição feita com `responseType: 'blob'`.
 *
 * Com blob, o corpo do erro chega como Blob e não como objeto: ler
 * `error.response.data.error` devolvia `undefined`, então a tela só conseguia
 * mostrar "Erro ao baixar ZIP. Verifique o console." para qualquer falha —
 * inclusive para os casos comuns (nenhum arquivo disponível, sessão expirada).
 */
export const lerErroDeDownload = async (error, mensagemPadrao) => {
    const resposta = error?.response;
    if (!resposta) {
        return 'Não foi possível falar com o servidor. Verifique sua conexão.';
    }

    try {
        const dados = resposta.data;
        const texto = dados instanceof Blob ? await dados.text() : dados;
        const corpo = typeof texto === 'string' ? JSON.parse(texto) : texto;
        if (corpo?.error || corpo?.msg) return corpo.error || corpo.msg;
    } catch (e) {
        // Corpo que não é JSON (HTML de proxy, por exemplo): fica na mensagem padrão.
    }

    return mensagemPadrao;
};
